import dynamic from 'next/dynamic';
import { ContentType } from 'types/publishedAssets';

const MapContentView = dynamic(() => import('./MapContentView'), {
  ssr: false,
});

interface Props {
  content: ContentType;
}

export function MapContent(props: Props) {
  return <MapContentView {...props} />;
}
